// test2766
(2766 && 0);
